import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { DeleteEmailTemplateRPC } from "./deleteEmailTemplateRPC";

export class DeleteEmailTemplateRPCClientImpl extends DeleteEmailTemplateRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: DeleteEmailTemplateRPC.Request): Promise<LeoRPCResult<DeleteEmailTemplateRPC.Response, DeleteEmailTemplateRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "email-cycle/DeleteEmailTemplate",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      DeleteEmailTemplateRPC.ResponseDTO,
      DeleteEmailTemplateRPC.Errors.ErrorsDTO,
      DeleteEmailTemplateRPC.Response,
      DeleteEmailTemplateRPC.Errors.Errors
    >(
      response,
      "email-cycle/DeleteEmailTemplate",
      DeleteEmailTemplateRPC.Response.fromDTO,
      DeleteEmailTemplateRPC.Errors.fromDTO
    );
  }
}
